import React from 'react';
import { Shield } from 'lucide-react';
import UsersManagement from '../settings/UsersManagement';
import RolesDepartmentsManagement from '../settings/RolesDepartmentsManagement';
import AuthorizationManagement from '../settings/AuthorizationManagement';
import ProfileSettings from '../settings/ProfileSettings';
import BillingPage from '../billing/BillingPage';
import AdminUsagePage from '../billing/AdminUsagePage';
import OrganizationManagement from '../settings/OrganizationManagement';
import CategoryManagement from '../settings/CategoryManagement';

interface SettingsContentProps {
  selectedMenuItem?: string;
  onMenuItemSelect?: (itemId: string) => void;
}

const SettingsContent: React.FC<SettingsContentProps> = ({ selectedMenuItem }) => {
  switch (selectedMenuItem) {
    case 'users':
      return <UsersManagement />;
    case 'roles-departments':
      return <RolesDepartmentsManagement />;
    case 'authorization':
      return <AuthorizationManagement />;
    case 'profile':
      return <ProfileSettings />;
    case 'billing':
      return <BillingPage />;
    case 'usage-analytics':
      return <AdminUsagePage />;
    case 'organizations':
      return <OrganizationManagement />;
    case 'categories':
      return <CategoryManagement />;
    default:
      return (
        <div className="flex-1 flex flex-col bg-gray-50 overflow-hidden">
          <div className="flex-1 flex items-center justify-center">
            <div className="text-center">
              <Shield className="w-16 h-16 text-gray-400 mx-auto mb-4" />
              <h3 className="text-lg font-medium text-gray-900 mb-2">Settings</h3>
              <p className="text-gray-500">Select a settings option from the sidebar to get started.</p>
            </div>
          </div>
        </div>
      );
  }
};

export default SettingsContent;
